import React from 'react';

import styled from '@emotion/styled';

const Chips = styled.div`
    background: #ffffff40;
    height: 30px;
    width: 30px;
    border-radius: ${({ theme }): string => theme.base.radius.s};
    position: absolute;
    left: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const ButtonChips: React.FunctionComponent<{ children: React.ReactNode }> = ({
    children,
}) => {
    return <Chips>{children}</Chips>;
};
